import Modal from '@/components/Modal/__new__/Modal.vue';
import InfiniteData from '@/components/DataProvider/InfiniteData.vue';
import { defineComponent } from '@vue/composition-api';
import PlaceWithPopover from '@/views/_components/PlaceWithPopover.vue';
export default defineComponent({
    components: { PlaceWithPopover, InfiniteData, Modal },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            required: true,
        },
        reportId: {
            type: String,
            required: true,
        },
    },
});
